import styled, { css } from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SliderCompoundStyle = styled.div`
  /* Parent
  ------------------------------- */
  width: 100%;

  ${props => {
    return css`
      zoom: ${props.demoZoomReverse};
    `
  }}

  /* Childrens
  ------------------------------- */
  .input {
    font-size: 14px;
  }

  .display-values {
    display: flex;
    justify-content: flex-end;
    color: ${VARIABLES.COLORS.BLUE_1};
    margin-bottom: 2rem;

    ${props => {
      return css`
        zoom: ${props.demoZoom};
      `
    }}

    .value-unit {
      margin-right: 8px;
    }

    .values {
      display: flex;
      width: 100%;
      gap: 20px;

      /* .text-fit-block {
        width: 100%;
        display: flex;
        align-items: center;
      } */

      .value::first-child {
        width: calc(100% - 60px);
      }
    }

    .value {
      display: flex;
      align-items: center;
      position: relative;

      &:before {
        content: '-';
        display: inline-block;
        padding: 0 0.5rem;
        position: absolute;
        left: -22px;
      }

      &:first-child {
        &:before {
          display: none;
          content: '';
        }
      }
    }
  }

  .slider {
    width: calc(100% - 20px);
    min-height: ${VARIABLES.ELEMENT_SIZES.SILDER_COMPOUND_HANDLE_HEIGHT + 'px'};
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-bottom: 9px;
  }

  .slider-tracks {
    margin-top: -3px;
  }

  .slider-handles {
    margin-top: -3px;

    .handler {
      ${props => {
        return css`
          zoom: ${props.demoZoom};
        `
      }}
    }
  }

  /* Modifiers
  ------------------------------- */
  /* &.sidebar-filter {
    background-color: ${VARIABLES.COLORS.GRAY_7};
    border: 1px solid ${VARIABLES.COLORS.GRAY_2};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    padding: 8px 14px;
  } */

  /* State
  ------------------------------- */
  /* &.is-disabled {
    position: relative;

    &.sidebar-filter {
      &:after {
        border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      }
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${VARIABLES.COLORS.GRAY_14};
      opacity: 0.5;
      z-index: ${VARIABLES.Z_INDEXS.LV_2};
    }
  } */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    /* &.sidebar-filter {
      padding: 8px 13px;
    } */
  }

  @media all and (max-width: 1440.98px) {
    /* &.sidebar-filter {
      padding: 7px 11px;
    } */
  }

  @media all and (max-width: 1366.98px) {
    /* &.sidebar-filter {
      padding: 7px 10px;
    } */
  }

  @media all and (max-width: 1280.98px) {
    /* &.sidebar-filter {
      padding: 6px 8px;
    } */
  }

  @media all and (max-width: 1024.98px) {
    /* &.sidebar-filter {
      padding: 5px;
    } */
  }
`

// railOuterStyle
// ============================================================
export const RailOuterStyle = styled.div`
  /* Parent
  ------------------------------- */
  position: absolute;
  width: 100%;
  height: ${VARIABLES.ELEMENT_SIZES.SILDER_COMPOUND_TRACK_HEIGHT * 3 + 'px'};
  transform: translate(0%, -50%);
  border-radius: 7px;
  cursor: pointer;

  /* Childrens
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

// railInnerStyle
// ============================================================
export const RailInnerStyle = styled.div`
  /* Parent
  ------------------------------- */
  position: absolute;
  width: 100%;
  height: 3px;
  transform: translate(0%, -50%);
  border-radius: 7px;
  pointer-events: none;
  background-color: ${VARIABLES.COLORS.GRAY_2};

  /* Childrens
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1366.98px) {
    height: 2px;
  }
`

// TickWrapperStyle
// ============================================================
export const TickWrapperStyle = styled.div`
  /* Parent
  ------------------------------- */

  /* Childrens
  ------------------------------- */
  .tick-line {
    position: absolute;
    margin-top: 14px;
    width: 1px;
    height: 5px;
    background-color: rgb(200, 200, 200);
    ${props => {
      return css`
        left: ${props.tick.percent + '%'};
      `
    }}
  }

  .tick-number {
    position: absolute;
    margin-top: 22px;
    font-size: 10px;
    text-align: center;

    ${props => {
      return css`
        margin-left: ${-(100 / props.count) / 2 + '%'};
        width: ${100 / props.count + '%'};
        left: ${props.tick.percent + '%'};
      `
    }}
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const TrackStyle = styled.div`
  /* Parent
  ------------------------------- */
  position: absolute;
  transform: translate(0%, -50%);
  height: 3px;
  z-index: ${VARIABLES.Z_INDEXS.LV_1};
  border-radius: 7px;
  cursor: pointer;

  ${props => {
    return css`
      margin-left: ${-(100 / props.count) / 2 + '%'};
      width: ${props.target.percent - props.source.percent + '%'};
      left: ${props.source.percent + '%'};
      background-color: ${props.disabled
        ? VARIABLES.COLORS.GRAY_5
        : VARIABLES.COLORS.BLUE_1};
    `
  }} /* Childrens
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1366.98px) {
    height: 2px;
  }
`

export const HandleWrapperStyle = styled.div`
  /* Parent
  ------------------------------- */
  .handler-control {
    position: absolute;
    transform: translate(-50%, -50%);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    z-index: 5;
    width: 24px;
    height: 28px;
    cursor: pointer;
    background-color: transparent;

    ${props => {
      return css`
        left: ${props.percent + '%'};
      `
    }}
  }

  .handler {
    position: absolute;
    transform: translate(-50%, -50%);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    z-index: 2;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow: 1px 1px 1px 1px ${VARIABLES.COLORS.SHADOW_3};
    cursor: pointer;
    background-color: transparent;
    background-color: white;

    ${props => {
      return css`
        left: ${props.percent + '%'};
      `
    }}
  }

  /* Childrens
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .handler-control {
      width: 22px;
      height: 26px;
    }

    .handler {
      width: 18px;
      height: 18px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .handler-control {
      width: 21px;
      height: 24px;
    }

    .handler {
      width: 16px;
      height: 16px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .handler-control {
      width: 19px;
      height: 22px;
    }

    .handler {
      width: 14px;
      height: 14px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .handler-control {
      width: 18px;
      height: 20px;
    }

    .handler {
      width: 12px;
      height: 12px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .handler-control {
      width: 16px;
      height: 18px;
    }
  }
`
